// extracted by mini-css-extract-plugin
export default {"footerWide":"Footer_footerWide__4smYx","footerContent":"Footer_footerContent__GLsTv","line":"Footer_line__XluuY"};